export enum InterruptionTabs {
  CANCEL = 'cancel',
  SUSPEND = 'suspend',
}

export interface InterruptionChart {
  subscriptions_total: number;
  subscriptions_amount: number;
  chart: Array<{
    total: number;
    reason: string;
    amount: number;
    percentage: number;
  }>;
}

export enum CustomerSearchTypes {
  NAME = 'customer_name',
  EMAIL = 'customer_email',
  DOCUMENT = 'customer_document',
}
export interface InterruptionFilter {
  id: string;
  date: [string, string];
  customer?: string;
  customer_type: CustomerSearchTypes;
  product_id: number[];
  invoice_id: string;
  reason_id: string[];
}
